module.exports = __webpack_public_path__ + "static/media/01_side_by_side.620cf506.jpg";